module.exports = __webpack_public_path__ + "static/media/HCMM787.f77b07ce.jpg";